"use client";
import AuthDrawer from "@/components/common/drawer/AuthDrawer/AuthDrawer";
import CommonImage from "@/components/common/image/CommonImage";
import { closeDrawer } from "@/redux/slices/authDrawerSlice";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";
import { FaCirclePlay } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import { Form, Input, Checkbox, Button } from "antd";
import {
  MobileOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import { T_TOKEN_STORE_KEY, TOKEN_STORE_KEY } from "@/constants/storage";
import { FaArrowRight } from "react-icons/fa6";
import { loginAfterAuthSuccess } from "@/helpers/auth";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import TeacherService from "@/services/api/TeacherService";
import { setTeacher } from "@/redux/slices/teacherSlice";
import Link from "next/link";

export default function Login() {
  const router = useRouter();

  const dispatch = useDispatch();

  const onFinish = async (values) => {
    try {
      const response = await TeacherService.login(values);

      if (response?.data) {
        const { token, user } = response.data;

        if (token) {
          Cookies.set(T_TOKEN_STORE_KEY, token, { expires: 7 });
          if (user) {
            dispatch(setTeacher(user));
          }
          toast.success(response.message || "সফলভাবে লগ ইন করেছেন", {
            autoClose: 1000,
          });

          router.push("/teacher/dashboard");
        }
      } else {
        toast.error(
          response.message || "লগইন ব্যর্থ হয়েছে, পুনরায় চেষ্টা করুন"
        );
      }
    } catch (error) {
      console.error("Login failed:", error);
      toast.error(
        error?.response?.data?.message || "লগইন করার সময় সমস্যা হয়েছে"
      );
    }
  };

  return (
    <>
      {" "}
      <ToastContainer />
      <section className="login_section section_padding-48">
        <div className="container">
          <div
            className="login-section-card bg-pattern"
            style={{
              backgroundImage: "url('/images/home-page/program-pattern.avif')",
            }}
          >
            <div className="grid grid-cols-12 gap-6">
              <div className="lg:col-span-5 col-span-12">
                <div className="login-page-card">
                  <div className="login-registation-card !mt-0">
                    <div className="top-title">
                      <CommonImage
                        src={"/images/login/login-title.avif"}
                        className="top-icon"
                        alt="Icon"
                      />
                      <span className="text-[#2e4e8d] [.dark_&]:text-d-white font-medium text-sm">
                        Login
                      </span>
                    </div>

                    <div className="login-form">
                      <h2 className="second-title">স্বাগতম আপনাকে</h2>

                      <Form
                        layout="vertical"
                        onFinish={onFinish}
                        className="login-reg-form"
                      >
                        <Form.Item
                          name="phone"
                          rules={[
                            { required: true, message: "ফোন নাম্বার দিন" },
                            {
                              pattern: /^0\d{10}$/,
                              message:
                                "সঠিক ১১ সংখ্যার ফোন নাম্বার দিন (০ দিয়ে শুরু)",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            placeholder="ফোন নাম্বার"
                            className="rounded"
                            addonBefore="+88"
                            maxLength={11}
                          />
                        </Form.Item>
                        <Form.Item
                          name="password"
                          rules={[{ required: true, message: "পাসওয়ার্ড দিন" }]}
                        >
                          <Input.Password
                            size="large"
                            placeholder="পাসওয়ার্ড"
                            iconRender={(visible) =>
                              visible ? (
                                <EyeOutlined />
                              ) : (
                                <EyeInvisibleOutlined />
                              )
                            }
                            className="rounded"
                          />
                        </Form.Item>
                        <div className="flex justify-between flex-wrap gap-3 items-center text-base mb-4 login-text-wrap">
                          <Checkbox className="pass-save-text">
                            পাসওয়ার্ড সেভ রাখুন
                          </Checkbox>
                          <Link
                            href="/teacher/forget-password"
                            className="pass-read-text"
                          >
                            পাসওয়ার্ড ভুলে গেছেন?
                          </Link>
                        </div>
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className="login-regictation-submit-btn"
                          >
                            লগ ইন <FaArrowRight />
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-7 col-span-12">
                <div className="video-part">
                  <div className="login-video-thumbnail">
                    <CommonImage
                      src={"/images/login/login-video-thumbnail.avif"}
                      alt={"Image"}
                      className="login-thumbnail"
                    />
                    <div className="login-playbtn">
                      <button className="play-btn">
                        <FaCirclePlay className="play-icon" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
